import { IconType } from "./icons.types";

export const CourseIcon = ({ className, color = "#000000" }: IconType) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.0001 4.04447V15.9187M4.16675 5.87887C5.22156 6.04222 6.39823 6.31381 7.50008 6.7399M4.16675 9.2122C4.69966 9.29473 5.26366 9.40488 5.83341 9.54863M3.32869 1.50939C5.17734 1.71829 7.66102 2.28027 9.43077 3.52037C9.7709 3.75871 10.2293 3.75871 10.5694 3.52037C12.3391 2.28027 14.8228 1.71829 16.6715 1.50939C17.5864 1.40601 18.3334 2.17002 18.3334 3.11265V12.5C18.3334 13.4426 17.5864 14.2069 16.6715 14.3103C14.8228 14.5192 12.3391 15.0811 10.5694 16.3212C10.2293 16.5596 9.7709 16.5596 9.43077 16.3212C7.66102 15.0811 5.17734 14.5192 3.32869 14.3103C2.41377 14.2069 1.66675 13.4426 1.66675 12.5V3.11265C1.66675 2.17002 2.41377 1.40601 3.32869 1.50939Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
